export default (args: {dispatchDataV2: Function}) => (columnId: string) => {
  
  return args.dispatchDataV2({
    type: "DELETE_COLUMN",
    value: columnId
  });
}